import { LocalLink as Link } from '@/lib/locale';

export const LogoMark = () => (
  <span className="grid h-[30px] w-[30px] flex-none place-items-center rounded-[10px] bg-accent" aria-hidden="true">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFFFFF">
      <path d="M12 21s-7-4.4-9.3-9C1 8.6 3 5 6.5 5c2 0 3.5 1.1 5.5 3 2-1.9 3.5-3 5.5-3C21 5 23 8.6 21.3 12 19 16.6 12 21 12 21Z" />
    </svg>
  </span>
);

export const Logo = ({ className = '', onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid="logo-link"
    className={`inline-flex min-h-[44px] items-center gap-2 whitespace-nowrap font-heading text-[22px] font-extrabold tracking-[-0.03em] text-candy-ink max-[359px]:gap-1.5 max-[359px]:text-[18px] md:text-[26px] ${className}`}
  >
    <LogoMark />
    Blissful Play
  </Link>
);
